'use strict';

import $ from 'jquery';
import jQuery from 'jquery';

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

export default function AjaxComments() {

  var fadeMessage = () => {
    var $msg = $('#comment-status');
    $msg.css('display','block');
    setTimeout(
      function(){
        $msg.fadeOut('7000');
      }, 6000);    
  }

  jQuery('document').ready(function($){
      // Get the comment form
      var commentform=$('#commentform');
      // Add a Comment Status message
      commentform.prepend('<div id="comment-status" ></div>');
      // Defining the Status message element 
      var statusdiv = $('#comment-status');

      commentform.submit(function(){
        // Serialize and store form data
        var formdata = commentform.serialize();
        //Add a status message
        statusdiv.html('<p class="ajax-placeholder">Processing...</p>');
        //Extract action URL from commentform
        var formurl = commentform.attr('action');

        //Post Form with data
        $.ajax({
          type: 'post',
          url: formurl,
          data: formdata,
          error: function(XMLHttpRequest, textStatus, errorThrown){
            statusdiv.html('<p class="ajax-error" >You might have left one of the fields blank, or be posting too quickly</p>');
            fadeMessage();        
          },
          success: function(data, textStatus){
            if(data=="success" || textStatus == "success"){
              statusdiv.html('<p class="ajax-success" >Thanks for your comment. We will publish your response once verified.</p>');
            }
            else {
              statusdiv.html('<p class="ajax-error" >Please wait a while before posting your next comment</p>');
              commentform.find('textarea[name=comment]').val('');
            }
            fadeMessage();
          }
        });
        return false;
      });
    });

}